import type { Draft } from '../data/types';
import styles from './Welcome.module.css';

interface WelcomeProps {
  drafts: Draft[];
  onBegin: () => void;
  onOpen: (id: string) => void;
  onDelete: (id: string) => void;
}

export function Welcome({ drafts, onBegin, onOpen, onDelete }: WelcomeProps) {
  return (
    <section className={styles.welcome}>
      <h1 className={styles.heading}>the negotiation letter</h1>
      <p className={styles.subtitle}>write what you want, before you need to say it</p>
      <p className={styles.body}>
        eleven small sections — intent, context, what you want, what you do not,
        safewords, aftercare, exit terms, signature. fill what feels true; leave
        what does not. drafts auto-save in your browser and never leave it.
      </p>
      <button type="button" className={styles.begin} onClick={onBegin}>
        begin a draft
      </button>

      {drafts.length > 0 && (
        <section className={styles.draftsSection}>
          <h2 className={styles.draftsHeading}>your drafts</h2>
          <ul className={styles.draftsList}>
            {drafts.map((d) => (
              <li key={d.id} className={styles.draftItem}>
                <button
                  type="button"
                  className={styles.draftBtn}
                  onClick={() => onOpen(d.id)}
                >
                  <span className={styles.draftTitle}>{d.title || 'untitled draft'}</span>
                  <span className={styles.draftDate}>
                    edited {new Date(d.updatedAt).toLocaleDateString()}
                  </span>
                </button>
                <button
                  type="button"
                  className={styles.deleteBtn}
                  onClick={() => {
                    if (confirm('delete this draft?')) onDelete(d.id);
                  }}
                  aria-label="delete"
                >
                  ×
                </button>
              </li>
            ))}
          </ul>
        </section>
      )}
    </section>
  );
}
